export enum TranslationContext {
  DeviceRegistration = "deviceRegistration",
  General = "general",
  Settings = "settings",
  ProductDetails = "productDetails",
  ProductListing = "productListing",
  Basket = "basket",
  Checkout = "checkout",
  ConfirmedOrder = "confirmedOrder",
}
